import { z } from 'zod';
// ── crearTipoAusenciaSchema — POST /tipos-ausencia (Prompt AD) ───────────────
// Validación cruzada completa aquí porque en un alta el objeto llega
// completo — a diferencia de actualizarTipoAusenciaSchema (PATCH parcial),
// donde la regla cruzada depende del estado ya guardado en BD y se aplica
// en el servicio (mismo criterio que es_aprobador_final/aprobador_permisos_id
// en usuarios.ts, Prompt AB).
export const crearTipoAusenciaSchema = z
    .object({
    nombre: z.string().min(1).max(100),
    categoria: z.enum(['antiguedad', 'cupon_fijo', 'permisos_especiales']),
    // Prompt BB-1(RH) — opcional: si categoria='antiguedad', el servicio
    // fuerza "Vacaciones" sin importar el payload; si no, default=nombre
    // cuando se omite. Regla cruzada en el servicio, no aquí (mismo
    // criterio que anio_desde/anio_hasta).
    categoria_visible: z.string().min(1).max(100).optional(),
    anio_desde: z.coerce.number().int().positive().nullable().optional(),
    anio_hasta: z.coerce.number().int().positive().nullable().optional(),
    dias_otorgados: z.coerce.number().int().nonnegative(),
    // Solo 'antiguedad' (el servicio lo fuerza a NULL en las demás).
    // NULL/omitido = el saldo de nómina usa dias_otorgados.
    dias_otorgados_nomina: z.coerce.number().int().nonnegative().nullable().optional(),
})
    .superRefine((data, ctx) => {
    if (data.categoria === 'antiguedad' && (data.anio_desde === undefined || data.anio_desde === null)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['anio_desde'],
            message: 'anio_desde es obligatorio para categoría "antiguedad"',
        });
    }
    // cupon_fijo y permisos_especiales comparten la misma regla: sin años.
    if (data.categoria !== 'antiguedad' && (data.anio_desde != null || data.anio_hasta != null)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['anio_desde'],
            message: 'anio_desde/anio_hasta deben ir vacíos para esta categoría',
        });
    }
    if (data.anio_desde != null && data.anio_hasta != null && data.anio_hasta < data.anio_desde) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['anio_hasta'],
            message: 'anio_hasta debe ser mayor o igual a anio_desde',
        });
    }
});
// ── actualizarTipoAusenciaSchema — PATCH /tipos-ausencia/:id ─────────────────
// Parcial — la regla cruzada categoria↔anio_desde/anio_hasta se aplica en el
// servicio contra el estado final (actual + patch), no aquí.
export const actualizarTipoAusenciaSchema = z.object({
    nombre: z.string().min(1).max(100).optional(),
    categoria: z.enum(['antiguedad', 'cupon_fijo', 'permisos_especiales']).optional(),
    categoria_visible: z.string().min(1).max(100).optional(),
    anio_desde: z.coerce.number().int().positive().nullable().optional(),
    anio_hasta: z.coerce.number().int().positive().nullable().optional(),
    dias_otorgados: z.coerce.number().int().nonnegative().optional(),
    dias_otorgados_nomina: z.coerce.number().int().nonnegative().nullable().optional(),
    // Permite reactivar (activo: true) sin necesitar un endpoint de toggle
    // aparte — DELETE /:id ya cubre el camino de desactivar.
    activo: z.boolean().optional(),
});
//# sourceMappingURL=tipos-ausencia.js.map